/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Coaching_Pdf_TitleInputs */

const en_us2_coaching_pdf_title = /** @type {(inputs: Coaching_Pdf_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Report for ${i?.name}`)
};

const pt_br2_coaching_pdf_title = /** @type {(inputs: Coaching_Pdf_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Relatório de ${i?.name}`)
};

const pt_pt2_coaching_pdf_title = /** @type {(inputs: Coaching_Pdf_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Relatório de ${i?.name}`)
};

/** @type {(inputs: Coaching_Pdf_TitleInputs) => LocalizedString} */
const es_419_coaching_pdf_title = en_us2_coaching_pdf_title;

/** @type {(inputs: Coaching_Pdf_TitleInputs) => LocalizedString} */
const fr_fr2_coaching_pdf_title = en_us2_coaching_pdf_title;

/** @type {(inputs: Coaching_Pdf_TitleInputs) => LocalizedString} */
const de_de2_coaching_pdf_title = en_us2_coaching_pdf_title;

/** @type {(inputs: Coaching_Pdf_TitleInputs) => LocalizedString} */
const it_it2_coaching_pdf_title = en_us2_coaching_pdf_title;

/**
* | output |
* | --- |
* | "Report for {name}" |
*
* @param {Coaching_Pdf_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_pdf_title = /** @type {((inputs: Coaching_Pdf_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Pdf_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_pdf_title(inputs)
	if (locale === "es-419") return es_419_coaching_pdf_title(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_pdf_title(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_pdf_title(inputs)
	if (locale === "de-DE") return de_de2_coaching_pdf_title(inputs)
	if (locale === "it-IT") return it_it2_coaching_pdf_title(inputs)
	return en_us2_coaching_pdf_title(inputs)
});
export { coaching_pdf_title as "coaching.pdf_title" }